// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"54ca6ebc","186":"33e7f70d","472":"178548d7","622":"d7898853","863":"69c7d7ff","908":"49a5b075"}[chunkId] + ".chunk.js";
};